import { UserState } from '@store/states/user.state';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { BaseComponent } from '@components/base.component';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PaymentService } from '@services/payment.service';
import { PaymentPeriod, PaymentProduct } from '@interfaces/payment.interface';
import { groupBy } from 'lodash-es';
import { Router } from '@angular/router';
import APP_CONFIG from 'src/app/config/app.config';
import { environment } from 'src/environments/environment';
import { StorageService } from '@services/storage.service';
import { ClientService } from '@services/client.service';
import { TranslateService } from '@ngx-translate/core';
import { WindowRefService } from '@shared/window-ref';

declare const moment: any;

@Component({
    selector: 'app-pricing',
    templateUrl: './pricing.component.html',
    styleUrls: ['./pricing.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})
export class PricingComponent extends BaseComponent implements OnInit {
    @Select(UserState.data) public userData$: Observable<Record<string, any>>;

    @Input()
    public demo: boolean = false;

    public userData: Record<string, any>;

    public annual: PaymentPeriod = PaymentPeriod.YEARLY;
    annualMode: boolean = true;

    modalOpen: boolean = true;

    public val: { [key: string]: PaymentProduct[] };

    public constructor(
        public payment: PaymentService,
        private router: Router,
        private translate: TranslateService,
        private storage: StorageService,
        private client: ClientService,
        protected win: WindowRefService
    ) {
        super();
    }

    public ngOnInit(): void {
        this.userData$.subscribe((val) => {
            this.userData = val;
        });

        this.payment.getProducts().subscribe((val) => {
            this.val = groupBy(val, 'subscription_type') as any;
        });

        if (this.storage.isset(APP_CONFIG.paymentModalTrial)) {
            this.modalOpen = false;
        }
    }

    public signIn(): void {
        this.router.navigate(['/page/see/pricing'], { queryParams: { signin: '' } });
    }

    public checkout(productId: number, product: PaymentProduct): void {
        this.win.nativeWindow.dataLayer.push({
            event: 'begin_checkout',
            ecommerce: {
                currency: 'USD', // currency code
                value: product.amount,
                items: [
                    {
                        item_name: product.permission.permission_name,
                        item_id: product.id,
                        price: product.amount,
                        subscription: product.subscription_type,
                        quantity: '1',
                    },
                ],
            },
        });

        document.location.href = `${environment.web}/payment/checkout?lang=${this.translate.currentLang}&product=${productId}`;
    }

    get products(): PaymentProduct[] {
        if (!this.val || !this.val[this.annual]) {
            return [];
        }

        return this.val[this.annual]!.filter(
            (v) => v.payment_tier_id === this.client.tier && !v.product_id.includes(environment.appleId)
        );
    }

    expired(id: number): boolean {
        return this.hasPermission(id) && !this.isValid(id);
    }

    isAll(name: string): boolean {
        return name === 'all';
    }

    public closeModal(): void {
        this.modalOpen = false;
        this.storage.set(APP_CONFIG.paymentModalTrial, '1');
    }

    public getImage(permission: string): string {
        if (permission === 'betting_widgets') {
            return 'predictor.png';
        }
        if (permission === 'premium_stats') {
            return 'statistics+.png';
        }
        if (permission === 'tracker') {
            return 'tracker.png';
        }
        if (permission === 'stream') {
            return 'stream.png';
        }
        if (permission === 'american_sports') {
            return 'american-sports.png';
        }
        if (permission === 'stats') {
            return 'statistics.png';
        }
        return 'all.png';
    }

    isExpiredTrial(): boolean {
        if (this.userData?.permisions) {
            const data = this.userData.permisions.find((v: Record<string, any>) => v.permission === 'all');

            if (!data) {
                return false;
            }

            return this.modalOpen && !this.isValid(data.id);
        }

        return false;
        // if (this.userData?.permisions) {
        //     const data = this.userData.permisions.find((v: Record<string, any>) => v.id === id);

        //     if (!data) {
        //         return false;
        //     }

        //     return data.pivot.trial === 1;
        // }

        // return false;
    }

    isValid(id: number): boolean {
        if (this.userData?.permisions) {
            const data = this.userData.permisions.find((v: Record<string, any>) => v.id === id);

            if (!data) {
                return false;
            }
            const today = moment();

            return !today.isAfter(data.pivot.valid_to);
        }

        return false;
    }

    isTrial(id: number): boolean {
        if (this.userData?.permisions) {
            const data = this.userData.permisions.find((v: Record<string, any>) => v.id === id);

            if (!data) {
                return false;
            }

            return data.pivot.trial === 1;
        }

        return false;
    }

    hasPermission(id: number): boolean {
        if (this.userData?.permisions) {
            const data = this.userData.permisions.find((v: Record<string, any>) => v.id === id);

            if (!data) {
                return false;
            }

            return true;
        }

        return false;
    }

    validity(id: number): string | false {
        if (this.userData?.permisions) {
            const data = this.userData.permisions.find((v: Record<string, any>) => v.id === id);

            if (!data) {
                return false;
            }

            return data.pivot.valid_to;
        }

        return false;
    }

    public onAnnualChange(mode: boolean): void {
        this.annual = mode ? PaymentPeriod.YEARLY : PaymentPeriod.MONTHLY;
        this.annualMode = mode;
    }
}
